export default __webpack_public_path__ + "static/media/GigaBit.c24fc0dd.png";